import { useQuasar } from 'quasar'

export default function useToaster() {
  const $q = useQuasar()

  function success(message) {
    $q.notify({
      message,
      color: 'positive',
      icon: 'check_circle',
      position: 'top-right',
    })
  }

  function error(message) {
    $q.notify({
      message,
      color: 'negative',
      icon: 'error',
      position: 'top-right',
    })
  }

  function info(message) {
    $q.notify({
      message,
      color: 'accent',
      icon: 'info',
      position: 'top-right',
    })
  }
  return {
    success,
    error,
    info,
  }
}
